import React, { ReactElement } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputText, InputTextProps } from "primereact/inputtext";

interface InputProps extends InputTextProps {
  label: string;
  name: string;
  value: any;
  warn: string;
  isRequired?: boolean;
  extendedLabel?: string | ReactElement;
}
export default function Input(props: InputProps) {
  const { name, label, warn, extendedLabel, ...rest } = props;
  const { setFieldTouched, setFieldValue } = useFormikContext();

  return (
    <div className="flex flex-column w-full py-2" id={name.split(".").pop()}>
      {label && !props?.hidden && (
        <label className={rest.isRequired ? "isRequired" : ""} htmlFor={name} id={name.split(".").pop()}>
          {" "}
          {label}
        </label>
      )}
      {extendedLabel && (
        <p className="helpertext">
          <i>{extendedLabel}</i>
        </p>
      )}
      <Field
        alt={name}
        name={name}
        {...rest}
        as={InputText}
        onChange={(e: any) => {
          setFieldTouched(name, true, true);
          setFieldValue(name, e.target.value);
        }}
      />
      {warn && <div className=" text-left fieldadv">{warn}</div>}

      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
